<template>
    <div
        id="programSelectorDiv"
        class="card p-2">
        <div v-show="!showSelector">
            <div
                id="ProgramStaticDisplayDiv"
                class="d-flex justify-content-between align-items-center flex-wrap">
                <h5
                    style="letter-spacing: 1px"
                    class="m-0 text-uppercase fw-bold">
                    {{ selectedProgram.Text }}
                </h5>
                <pc-button
                    id="changeProgram"
                    link
                    v-on:click="changeProgram">
                    {{ changeProgramLinkLabel }}
                </pc-button>
            </div>
        </div>
        <div v-show="showSelector">
            <div class="d-flex justify-content-between align-items-center">
                <pc-select
                    id="ProgramList"
                    v-bind:options="programs"
                    v-bind:model-value="selectedProgram.Value"
                    alt-label="Select program"
                    class="me-3 w-100"
                    value-prop="Value"
                    text-prop="Text"
                    v-on:update:model-value="programSelected" />
                <pc-button
                    id="changeProgramCancel"
                    link
                    v-on:click="cancel">
                    {{ cancelText }}
                </pc-button>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    import { KEYS, NAMESPACE } from "./i18n/pageContextSelector.i18n";
    import { KEYS as COMMON_KEYS, NAMESPACE as COMMON_NAMESPACE } from "I18n/common.i18n";
    import { mapI18n } from "Util/i18n";

    function changeUrlParamAndNavigate(param, value) {
        /**
         * queryParameters -> handles the query string parameters
         * queryString -> the query string without the fist '?' character
         * re -> the regular expression
         * m -> holds the string matching the regular expression
         */
        const queryParameters = {};
        const queryString = location.search.substring(1);
        const re = /([^&=]+)=([^&]*)/g;
        let m;

        // Creates a map with the query string parameters
        while ((m = re.exec(queryString))) {
            queryParameters[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
        }

        const values = value.split(":"); // into public ID and hostname
        queryParameters[param] = values[0];

        // figure out new host name
        const curHostName = location.hostname;
        const hostComponents = curHostName.split(".");
        if (values[1].length > 0 && hostComponents.length >= 2) {
            // not for localhost or local machine name, or empty host names
            if (hostComponents.length === 2) {
                hostComponents.unshift(values[1]);
            } else {
                hostComponents[0] = values[1];
            }
            const newHostName = hostComponents.join(".");
            window.location.href =
                location.protocol + "//" + newHostName + location.pathname + "?" + $.param(queryParameters);
        } else {
            /**
             * Replace the query portion of the URL.
             * jQuery.param() -> create a serialized representation of an array or
             *     object, suitable for use in a URL query string or Ajax request.
             */
            location.search = $.param(queryParameters); // Causes page to reload
        }
    }

    export default {
        props: { programs: { type: Array, required: true } },
        data() {
            const selectedProgram = this.programs.find((program) => program.Selected);
            return {
                selectedProgram: selectedProgram,
                showSelector: false
            };
        },
        computed: {
            ...mapI18n({ ...KEYS }, NAMESPACE),
            ...mapI18n(COMMON_KEYS, COMMON_NAMESPACE)
        },
        methods: {
            changeProgram: function () {
                this.showSelector = true;
            },
            cancel: function () {
                this.showSelector = false;
            },
            programSelected: function (value) {
                changeUrlParamAndNavigate("ProgramId", value);
            }
        }
    };
</script>
